import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function resetAdminUserPassword(id) {
  try {
    const res = await authFetch(
      `${BACKEND_URL}/admin/reset_password/${encodeURIComponent(id)}`,
      { method: "POST" },
    );
    const result = await res.json().catch(() => null);
    const success = res.ok && result?.success === true;

    return {
      success,
      ...normalizeApiMessage(
        result,
        success ? "비밀번호를 초기화했습니다." : "비밀번호 초기화에 실패했습니다.",
      ),
    };
  } catch {
    return {
      success: false,
      message: "서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.",
      messageKey: "api.common.networkError",
    };
  }
}
